import React, { useCallback } from 'react';
import { Component, ObjectManager } from '../../../../concepts/objects';
import { useResolve } from '../../../Container';
import { PreferredTextColor, TextSettings } from '../../entities/TextConventions';
import { UIField, UIFieldProps } from '../../entities/UIField';
import { useComponentObserver } from '../../visualization/ComponentObserver';
import { SimpleTextFieldInput } from './SimpleTextFieldInput';

export const CreateUnstyledTextFieldEditor = <T extends Component>(propertyName: string, getSettings: (owner: T) => TextSettings) =>
    ({ active, field }: UIFieldProps) => {

        const objects = useResolve(ObjectManager);
        const elmt = field.owner;
        useComponentObserver(elmt);

        // Support for PreferredTextColor
        const settings = getSettings(elmt as T);
        const fontColor = elmt.as(PreferredTextColor)?.getPreferredTextColor() ?? settings.fontColor;
        settings.fontColor = fontColor;

        const onChange = useCallback((nextValue: string) => {
            objects.update(u => {
                u.rolling(UIField.key(field));
                elmt.set(propertyName, nextValue);
            });
        }, [field]);

        const onCommit = useCallback(() => {
            objects.update(u => {
                u.rolling(UIField.key(field));
                u.noop();
            });
        }, []);

        return <SimpleTextFieldInput {...{
            active,
            field,
            settings,
            value: elmt.get(propertyName),
            onChange,
            onCommit,
        }} />;
    };
